export const getBulkSearchFormFields = (data) => {
  const {
    term,
    career
    // resetCourseId,
    // resetBusinessAreas
  } = data || {};

  return [

    {
      label: "Term*",
      type: "select",
      items: term,
      formKey: "term",
      //   onChange: resetCourseId,
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },
    {
      label: "Career*",
      type: "select",
      items: career,
      formKey: "career",
      //   onChange: resetCourseId,
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },
    {},
    {},
    {}
  ];
};

export const getFilterFormFields = dropdownData => {
  const { applicableComponents } = dropdownData || {};

  return [
    {
      label: 'Desc',
      type: 'select',
      items: applicableComponents,
      formKey: 'applicableComponents',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Week',
      type: 'select',
      items: weekBucketDropdown,
      formKey: 'weekBucket',
      onChange: () => { },
      loading: false,
      isMulti: false,
      placeholder: "Select",
      disbabled: false,
      isShowCount: false
    },

    {
      label: 'Effective date from',
      type: 'date',
      formKey: 'effectiveFrom',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: '',
    },
    {
      label: 'Effective date to',
      type: 'date',
      formKey: 'effectiveTo',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: '',
    },
  ]
}

export const initialForm = {
  applicableComponents: [],
  effectiveFrom: '',
  effectiveTo: '',
  weekBucket: ''
}

export const newRow = {
  applicableComponents: [],
  weekBucket: '',
  ruleType: '',
  ruleSubType: '',
  ruleValue: '',
  effectiveFrom: '',
  maxDaysApplicable:'',
  status: 'ACTIVE'
}

export const descDropdown = [
  { label: "Registration Fe", value: "REGISTRATION_FEE" },
  { label: "Admission Kit & Digital Access", value: "ADMISSION_FEE" },
  // { label: "Digital Access", value: "DIGITAL_ACCESS_FEE" },
  { label: "Tuition Fee", value: "TUITION_FEE" },
  { label: "Technology & Exam Fee", value: "TECH_AND_EXAM_FEE" },
  { label: "Classroom Fee", value: "CLASSROOM_FEE" },
]

export const ruleTypeDropdown = [
  { label: "Non Refundable", value: "NON_REFUNDABLE" },
  { label: "Fixed Deduct", value: "FIXED_DEDUCT" },
  { label: "Installment Deduct", value: "INSTALLMENT_DEDUCT" },
  { label: "Percent Deduct", value: "PERCENT_DEDUCT" },
  { label: "Min Of", value: "MIN_OF" },
]

export const ruleSubTypeInstallmentDropdown = Array.from({ length: 2 }, (_, i) => ({
  label: `Instalment ${i + 1}`,
  value: i + 1,
}));

export const ruleSubTypeMinOfDropdown = [
  { label: 'Percentage_Of_Installment_Paid & Usage_Cost', value: 'Percentage_Of_Installment_Paid,Usage_Cost' },
  { label: 'Percentage_Of_Installment_Paid & Future_Installment', value: 'Percentage_Of_Installment_Paid,Future_Installment' },
  { label: 'Percentage_Of_Installment_Payable & Future_Installment', value: 'Percentage_Of_Installment_Payable,Future_Installment' },
]

export const ruleSubTypeDropdown=[
  ...ruleSubTypeInstallmentDropdown,
  ...ruleSubTypeMinOfDropdown
]

export const weekBucketDropdown = [
  { label: 'Before Batch', value: 'BEFORE_BATCH' },
  { label: 'Week 1', value: 'Week1' },
  { label: 'Week 2', value: 'Week2' },
  { label: 'Week 3', value: 'Week3' },
  { label: 'Week 4', value: 'Week4' },
  { label: 'Week 5+', value: 'WEEK5_PLUS' },
]

export const ruleTypeValidation = (weekBucket) => {
  if (weekBucket?.value == "WEEK5_PLUS") {
    return [
      { label: "Non Refundable", value: "NON_REFUNDABLE" },
      { label: "Min Of", value: "MIN_OF" },
    ]
  }
  else
    return [{ label: "Non Refundable", value: "NON_REFUNDABLE" },
    { label: "Fixed Deduct", value: "FIXED_DEDUCT" },
    { label: "Installment Deduct", value: "INSTALLMENT_DEDUCT" },
    { label: "Percent Deduct", value: "PERCENT_DEDUCT" },
  ];
}

export const ruleSubTypeValidation = (ruleType) => {
  if (ruleType?.value == "MIN_OF" || ruleType?.value == "LOWER_OF") {
    return ruleSubTypeMinOfDropdown;
  }
  else if (ruleType?.value == "INSTALLMENT_DEDUCT")
    return ruleSubTypeInstallmentDropdown
  else return [];
}

export const disbledRuleSubTypeArray = ['NON_REFUNDABLE', 'FIXED_DEDUCT', 'PERCENT_DEDUCT'];

//RULE VALUE IS BASED ON RULE TYPE AND RULE SUB TYPE IF APPLICABLECOMPONENTS IS OTHER THEN NON REFUNDABLE THEN RULE VALUE IS DISABLED
export const checkDisabledSaveButton = (row) => {
  const isRuleValueEmpty = row?.ruleValue === null || row?.ruleValue === undefined || (typeof row?.ruleValue === 'string' && row.ruleValue.trim() === '');

  if (!row?.applicableComponents?.length ||
    !row?.weekBucket ||
    !row?.ruleType ||
    (row?.ruleType?.value == "INSTALLMENT_DEDUCT" && !row?.ruleSubType) ||
    (row?.ruleType?.value == "MIN_OF" && !row?.ruleSubType) ||
    !row?.effectiveFrom ||
    (row?.ruleType?.value !== "NON_REFUNDABLE" && isRuleValueEmpty)
  ) {
    return true
  }
  return false
}

